import { AnyAction, createReducer } from '@reduxjs/toolkit';
import {
	assetGridClearExcludedList,
	assetGridExcludeItem,
	assetGridIncludeItem,
	clearAssets,
	getAssetResolved,
	getGridData,
	getGridDataRejected,
	getGridDataReset,
	getGridDataResolved,
	getSensorResolved,
	getSystemAssetTypes,
	getSystemAssetTypesRejected,
	getSystemAssetTypesResolved,
	setMultipleAssetRequestsStatus,
} from '@Actions/asset';

import { AssetStoreState } from '@Types/asset.types';

export const initialState: AssetStoreState = {
	assets: [],
	sensors: [],
	assetGrid: {
		loading: false,
		items: [],
		pagination: {
			current: 1,
			pages: 1,
			total: 10,
			limit: 10,
		},
		sort: undefined,
		sortDescending: false,
		filterModel: undefined,
	},
	excludedList: [],
	systemAssets: {},
	systemAssetsStatus: 'idle',
	multipleAssetRequestsStatus: 'idle',
};

interface RiskReducer {
	[x: string]: (
		state: AssetStoreState,
		action: AnyAction,
	) => AssetStoreState | undefined;
}

const reducer: RiskReducer = {
	[getAssetResolved.toString()]: (state, action) => ({
		...state,
		assets: [...state.assets, action.payload],
	}),
	[setMultipleAssetRequestsStatus.toString()]: (state, action) => ({
		...state,
		multipleAssetRequestsStatus: action.payload,
	}),
	[getSensorResolved.toString()]: (state, action) => ({
		...state,
		sensors: [...state.sensors, action.payload],
	}),
	[clearAssets.toString()]: () => ({
		...initialState,
	}),
	[getGridData.toString()]: state => ({
		...state,
		assetGrid: {
			...state.assetGrid,
			loading: true,
		},
	}),
	[getGridDataResolved.toString()]: (state, action) => ({
		...state,
		assetGrid: { ...action.payload, loading: false },
	}),
	[getGridDataRejected.toString()]: state => ({
		...state,
		assetGrid: { ...state.assetGrid, loading: false },
	}),
	[getGridDataReset.toString()]: state => ({
		...state,
		assetGrid: initialState.assetGrid,
	}),
	[getSystemAssetTypes.toString()]: state => ({
		...state,
		systemAssetsStatus: 'loading',
	}),
	[getSystemAssetTypesResolved.toString()]: (state, action) => ({
		...state,
		systemAssets: action.payload,
		systemAssetsStatus: 'success',
	}),
	[getSystemAssetTypesRejected.toString()]: state => ({
		...state,
		systemAssetsStatus: 'error',
	}),
	[assetGridExcludeItem.toString()]: (state, action) => ({
		...state,
		excludedList: [...state.excludedList, action.payload],
	}),
	[assetGridIncludeItem.toString()]: (state, action) => ({
		...state,
		excludedList: state.excludedList.filter(
			item => item !== action.payload,
		),
	}),
	[assetGridClearExcludedList.toString()]: state => ({
		...state,
		excludedList: [],
	}),
};

export default createReducer(initialState, reducer);
